/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Deleteaccountfailed2Inputs */

const zh_danger_deleteaccountfailed2 = /** @type {(inputs: Danger_Deleteaccountfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除账户失败`)
};

const en_danger_deleteaccountfailed2 = /** @type {(inputs: Danger_Deleteaccountfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete account`)
};

const es_danger_deleteaccountfailed2 = /** @type {(inputs: Danger_Deleteaccountfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar la cuenta`)
};

/**
* | output |
* | --- |
* | "Failed to delete account" |
*
* @param {Danger_Deleteaccountfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_deleteaccountfailed2 = /** @type {((inputs?: Danger_Deleteaccountfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Deleteaccountfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_deleteaccountfailed2(inputs)
	if (locale === "en") return en_danger_deleteaccountfailed2(inputs)
	return es_danger_deleteaccountfailed2(inputs)
});
export { danger_deleteaccountfailed2 as "danger_deleteAccountFailed" }